<template>  
<div> <!-- root element start -->

    <div class="container-fluid mt-2">

          <div class="row">
            <div class="col-12 col-lg-4">
              <org-single-details @onSecComplete="onSecondary"></org-single-details>
              <org-single-contacts @onSecComplete="onSecondary"></org-single-contacts>
            </div>

            <div class="col-12 col-lg-8">
              <component 
                :is="rightView" 
                :prop1="prop1" 
                :prop2="prop2" 
                :prop3="prop3" 
                @onSComplete="successComplete" 
                @onUComplete="unsuccessComplete" 
                @onSecComplete="onSecondary"
              >
              </component>
            </div>

           </div>

    </div><!--  end container-fluid div -->
</div> <!-- root element end -->
</template>


<script>
import {store} from '../../stores/org-main-store.js'

import orgDetails from '../orgSinglePageComponents/org-single-details.vue'
import orgContacts from '../orgSinglePageComponents/org-single-contacts.vue'
import orgQuotes from '../orgSinglePageComponents/org-single-quotes.vue'

import contactCreate from '../utilityComponents/contactComponents/contact-create.vue'
import orgEdit from '../utilityComponents/orgComponents/org-edit.vue'
import addressEdit from '../utilityComponents/addressComponents/address-edit.vue'

import quoteCreate from '../utilityComponents/quoteComponents/quote-create.vue'
import viewQuote from '../utilityComponents/quoteComponents/quote-view.vue'
import emailQuote from '../utilityComponents/quoteComponents/quote-email.vue'

export default {
  store,
  props: ['org'],
  data: function () {
    return { 

    }
  },
  computed: {
    rightView () { return this.$store.state.rightView },
    prop1 () { return this.$store.state.prop1 },
    prop2 () { return this.$store.state.prop2 },
    prop3 () { return this.$store.state.prop3 },
  },
  watch: {
    
  },
  mounted() {
    this.getOrgDetails();
    this.getOrgContacts();
    this.getOrgQuotes();
  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },
    getOrgDetails() { this.$store.dispatch("getOrgDetails", { org: this.org } ); }, 
    getOrgContacts() { this.$store.dispatch("getOrgContacts", { org: this.org } ); }, 
    getOrgQuotes() { this.$store.dispatch("getOrgQuotes", { org: this.org } ); }, 
    
    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'contact-add':
        // code to run the "get all contacts method" from store
        _this.getOrgContacts();
        _this.changeRightView('org-single-quotes', '', '', '');
        break;
        case 'quote-save':
        // code to run the "get all contacts method" from store
        _this.getOrgQuotes();
        _this.changeRightView('org-single-quotes', '', '', '');
        break;
        case 'address-edit':
        // code to run the "get all contacts method" from store
        _this.getOrgDetails();
        _this.changeRightView('org-single-quotes', '', '', '');
        break;
        case 'org-edit':
        // code to run the "get all contacts method" from store
        _this.getOrgDetails();
        _this.changeRightView('org-single-quotes', '', '', '');
        break;
        case 'quote-email':
        var setup = [value[1]]
          _this.changeRightView('quote-view', '', '', setup);
        break;
        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'contact-add':
          _this.changeRightView('org-single-quotes', '', '', '');
        break;
        case 'quote-add':
          _this.changeRightView('org-single-quotes', '', '', '');
        break;
        case 'address-edit':
          _this.changeRightView('org-single-quotes', '', '', '');
        break;
        case 'org-edit':
          _this.changeRightView('org-single-quotes', '', '', '');
        break;
        case 'quote-view':
          _this.changeRightView('org-single-quotes', '', '', '');
        break;
        case 'quote-email':
          var setup = [value[1]]
          _this.changeRightView('quote-view', '', '', setup);
        break;
        default:
      }
    },
    onSecondary(value){
      var _this = this;
      switch(value[0]) {
        case 'launchAddContact':
          var setup = ['','',_this.org];
          _this.changeRightView('create-contact', '', '', setup);
        break;
        case 'launchAddQuote':
          var setup = ['','',_this.org];
          _this.changeRightView('create-quote', '', '', setup);
        break;
        case 'launchEditAddress':
          var setup = ['','',value[1]];
          _this.changeRightView('address-edit', '', '', setup);
        break;
        case 'launchEditOrg':
          var setup = ['','',value[1]];
          _this.changeRightView('org-edit', '', '', setup);
        break;
        case 'quote-view':
          var setup = [value[1]]
          _this.changeRightView('quote-view', '', '', setup);
        break;
        case 'quote-email':
          var setup = [value[1]]
          _this.changeRightView('quote-email', '', '', setup);
        break;
        default:
      }
    },

  },    
  components:{
    'org-single-details' : orgDetails,
    'org-single-contacts' : orgContacts,
    'org-single-quotes' : orgQuotes,

    'create-contact': contactCreate,
    
    'org-edit' : orgEdit,
    'address-edit' : addressEdit,

    'create-quote': quoteCreate,
    'quote-view' : viewQuote,
    'quote-email' : emailQuote,
  },
  filters: {

  }
}
</script>
